import { render, staticRenderFns } from "./publicInstitutions.vue?vue&type=template&id=60840c1e&"
import script from "./publicInstitutions.vue?vue&type=script&lang=js&"
export * from "./publicInstitutions.vue?vue&type=script&lang=js&"
import style0 from "./publicInstitutions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports